// import Vue from 'vue'
import axios from 'axios'
let url = {
    lately:'/wapi/hr/recruit/getLately' // 获取上次填的提供宿舍用餐情况等
};

function ReleaseAjax(urlmark) {
    let surl = url[urlmark];
    return new Promise((resolve,reject) => {
        axios.get(surl).then(res => {
            resolve(res)
        }).catch(res => {
            reject(res)
        })
    })
}

let btnArr = [
    {
        btn:'立即发布',
        txt:'发布岗位'
    },
    {
        btn:'确认修改',
        txt:'修改岗位'
    },
    {
        btn:'修改并发布上线',
        txt:'修改上线'
    }
];

export {
    ReleaseAjax,
    btnArr
}



// WEBPACK FOOTER //
// ./src/pages/posts/release.js